document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.show-feature', {
        slidesPerView: 1.184,
        spaceBetween: 16,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        pagination: {
            el: '.pagination',
            clickable: true,
            renderBullet: function (index, className) {
                const pageNumber = (index + 1).toString().padStart(2, '0');
                return `<p class="${className}">${pageNumber}</p>`;
            },
        },
        breakpoints: {
            991: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
        },
        on: {
            afterInit: function () {
                updateNavigationButtons(this);
            },
            slideChange: function () {
                updateNavigationButtons(this);
            },
        },
    });

    function updateNavigationButtons(swiper) {
        const prevButton = document.querySelector('.button-prev');
        const nextButton = document.querySelector('.button-next');

        if (swiper.isBeginning) {
            prevButton.style.opacity = '0.35';
            prevButton.style.pointerEvents = 'none';
        } else {
            prevButton.style.opacity = '1';
            prevButton.style.pointerEvents = 'auto';
        }

        if (swiper.isEnd) {
            nextButton.style.opacity = '0.35';
            nextButton.style.pointerEvents = 'none';
        } else {
            nextButton.style.opacity = '1';
            nextButton.style.pointerEvents = 'auto';
        }
    }

    window.addEventListener('resize', function () {
        swiper.update();
        updateNavigationButtons(swiper);
    });
});
